import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AssetClassModel } from 'src/app/core/asset_class';
import { AssetClassTenure } from 'src/app/core/comparable';
import { ConsiderationCriterionService } from 'src/app/core/valuation/_services/consideration-criterion.service';
import { SLMethodResult } from '../../result-data-types';
import { StraightLineMethodData } from '../../straight-line-method-types';

@Component({
  selector: 'kt-straightline-method',
  templateUrl: './straight-line-method.component.html',
  styleUrls: [
    './straight-line-method.component.scss',
    '../headline-to-effective.component.scss'
  ]
})
export class StraightlineMethodComponent implements OnInit {
  @Input() tpCurrency: string;
  @Input() consideration: AssetClassTenure;
  @Output() valueComputed = new EventEmitter<SLMethodResult>();
  data: StraightLineMethodData;
  total_consideration: number = undefined;
  capital_payment: number = undefined;
  constructor(
    private considerationCriterionService: ConsiderationCriterionService,
  ) { }

  ngOnInit(): void {
    const isSameCurrency = this.consideration.currency === this.tpCurrency;
    const conv = this.consideration.conversion.find(c => c.quote_currency === this.tpCurrency);
    this.total_consideration = isSameCurrency
      ? this.consideration.total_consideration
      : conv 
        ? this.consideration.total_consideration * conv.exchange_rate
        : undefined;
    this.capital_payment = isSameCurrency
      ? Number(this.consideration.cap_payment)
      : conv
        ? Number(this.consideration.cap_payment) * conv.exchange_rate
        : undefined;
    this.data = this.considerationCriterionService.computeStraightLineMethod(this.consideration, this.tpCurrency);
    this.valueComputed.emit({
      calculatedValue: this.data.effectiveRent
    });
  }

  isInValid(): boolean {
    return false;
  }
}